<section class="login-2">

  <div class="container">
    <div class="row login-box">
      <div class="col-lg-6 col-md-12 bg-img ">
        <div class="info">
          <div class="info-text">
            <p class="welcome-text">Welcome to</p>
            <p class="zyno-tilte">YCP Procurement</p>
          </div>
        </div>
      </div>

  <div class="col-lg-6 col-md-12">
    <div class="login-background form-info">
      <div class="card-body text-black" style="color:#000">
        <img src="../../assets/images/ycp_iconss.jfif" class="img-fluid" />
        <p class="small">Enter <span class="title_vendor-login">Vendor login </span> credentials below to proceed.</p>
        <form name="loginForm" (ngSubmit)="loginForm.valid" #loginForm="ngForm" novalidate>

          <label class="control-label">Vendor Name</label>
          <div class="form-group login-formgroup-v input-container" style="margin-top: 5px;">
            <i class="fa fa-user icon"></i>
            <input type="text" class="form-control" name="vendorUserName" id="vendorUserName"
              [(ngModel)]="login.vendorUserName" (ngModelChange)="login.vendorUserName = login.vendorUserName?.trim()"
              #vendorUserName="ngModel" required
              [ngClass]="{ 'is-invalid': loginForm.submitted && vendorUserName.errors }">
            <div *ngIf="loginForm.submitted && vendorUserName.errors" class="invalid-feedback">
              <div *ngIf="vendorUserName.errors['required']">Employee code is required</div>
            </div>
          </div>


          <label class="control-label">Password</label>
          <div class="form-group input-container" style="position: relative; margin-top: 5px;">
            <i class="fa fa-key icon"></i>
            <input [type]="show_button ? 'text' : 'password'" class="form-control" name="vendorPassword"
              id="vendorPassword" [(ngModel)]="login.vendorPassword" #vendorPassword="ngModel" required
              [ngClass]="{ 'is-invalid': loginForm.submitted && vendorPassword.errors }">
            <span
              style="position: absolute; right: 5px; top: 50%; transform: translateY(-50%); cursor: pointer; color: rgb(153, 132, 97); font-size: 18px;"
              title="View Password">
              <i [ngClass]="show_button ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'" (click)="showPassword()"></i>
            </span>
            <div *ngIf="loginForm.submitted && vendorPassword.errors" class="invalid-feedback">
              <div *ngIf="vendorPassword.errors['required']">Password is required</div>
            </div>
          </div>


          <div class="d-flex text-center justify-content-between mt-2">
            <!-- <a [routerLink]="['/unableloginvendor']" class="text-decoration-none forgotPassword">Unable to
              login
            </a> -->
            <a [routerLink]="['/vendor-forgot-password']" class="text-decoration-none forgotPassword">Forgot
              password</a>
          </div>


          <div class="loginVendorButton">
            <button type="button" class="newloginbtn" (click)="loginUser()">Login</button>
            <div class="text-center">or</div>
            <button type="button" class="newloginbtn" (click)="loginAdmin()">Admin
              Login</button>
          </div>
        </form>
      </div>
    </div>
  </div>


    </div>
  </div>



</section>







<!-- <section class="vh-100 backs-image d-flex justify-content-center align-items-center">
  <div class="col-md-8 col-lg-6">
    <div class="login-background card text_side_right">
      <div class="card-body text-black" style="color:#000">
        <img src="../../assets/logo/image (2).png" class="img-fluid" />

        <form name="loginForm" (ngSubmit)="loginForm.valid" #loginForm="ngForm" novalidate>
    
          <label class="control-label">Vendor Name</label>
          <div class="form-group login-formgroup-v input-container" style="margin-top: 5px;">
            <i class="fa fa-user icon"></i>
            <input type="text" class="form-control" name="vendorUserName" id="vendorUserName"
              [(ngModel)]="login.vendorUserName"
              (ngModelChange)="login.vendorUserName = login.vendorUserName?.trim()" #vendorUserName="ngModel"
              required [ngClass]="{ 'is-invalid': loginForm.submitted && vendorUserName.errors }">
            <div *ngIf="loginForm.submitted && vendorUserName.errors" class="invalid-feedback">
              <div *ngIf="vendorUserName.errors['required']">Employee code is required</div>
            </div>
          </div>

         
          <label class="control-label">Password</label>
          <div class="form-group input-container" style="position: relative; margin-top: 5px;">
            <i class="fa fa-key icon"></i>
            <input [type]="show_button ? 'text' : 'password'" class="form-control" name="vendorPassword"
              id="vendorPassword" [(ngModel)]="login.vendorPassword" #vendorPassword="ngModel" required
              [ngClass]="{ 'is-invalid': loginForm.submitted && vendorPassword.errors }">
            <span
              style="position: absolute; right: 5px; top: 50%; transform: translateY(-50%); cursor: pointer; color: rgb(153, 132, 97); font-size: 18px;"
              title="View Password">
              <i [ngClass]="show_button ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'"
                (click)="showPassword()"></i>
            </span>
            <div *ngIf="loginForm.submitted && vendorPassword.errors" class="invalid-feedback">
              <div *ngIf="vendorPassword.errors['required']">Password is required</div>
            </div>
          </div>

        
          <div class="d-flex text-center justify-content-between mt-2">
            <a [routerLink]="['/unableloginvendor']" class="text-decoration-none" style="color: blue;">Unable to login</a>
            <a [routerLink]="['/vendor-forgot-password']" class="text-decoration-none" style="color: blue;">Forgot Password</a>
          </div>

         
          <div class="loginVendorButton">
            <button type="button" class="btn btn-primary newloginbtn btn-block"
              (click)="loginUser()">Login</button>
            <div class="text-center">or</div>
            <button type="button" class="btn btn-primary newloginbtn btn-block"
              (click)="loginAdmin()">Admin Login</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section> -->